import { Edd } from "types/edd";
import { ProcessData } from "types/process";
import { ApiService } from "utils/requestService";

export const updateEdd = (data: Partial<Edd>) => ApiService.patch<ProcessData<unknown>>(`/extra_edd_request`, data);

export const submitEdd = () => ApiService.patch<ProcessData<unknown>>(`/extra_edd_request/submit`);
